export const setListaPastas = (state, payload) => {
    state.listaPastas = payload;
};

export const setListaArquivos = (state, payload) => {
    state.listaArquivos = payload;
};